import React from 'react'
import './services.css'
import {BiCheck} from 'react-icons/bi'

const Services = () => {
  return (
    <section id="services" className='card-container'>
      <h5>What I Offer</h5>
      <h2>Services</h2>

      <div className="container services__container">
        
		<article className="service">

          	<div className="service__head">
            	<h3>Frontend Development</h3>
			</div>

            <ul className="service__list">
              	<li>
					<BiCheck className='service__list-icon'/>
					<p>Advance HTML, CSS skills</p>
			  	</li>
			  	<li>
					<BiCheck className='service__list-icon'/>
					<p>Bootstrap & Tailwind</p>
			  	</li>
			  	<li>
					<BiCheck className='service__list-icon'/>
					<p>ejs & jinja</p>
			  	</li>
			  	<li>
					<BiCheck className='service__list-icon'/>
					<p>React.js</p>
			  	</li>
			  	<li>
					<BiCheck className='service__list-icon'/>
					<p>state handling using Redux</p>
			  	</li>
			  	<li>
					<BiCheck className='service__list-icon'/>
					<p>Library tools like chart.js, mui, data-frame</p>
			  	</li>
            </ul>

        </article>
		{/* END OF UI/UX */}
        
		<article className="service">

          	<div className="service__head">
            	<h3>Machine Learning</h3>
			</div>

            <ul className="service__list">
			  	<li>
					<BiCheck className='service__list-icon'/>
					<p>Numpy, Pandas, Matplotlib, etc</p>
			  	</li>
			  	<li>
					<BiCheck className='service__list-icon'/>
					<p>Good understanding of Scikit-learn, Tensorflow</p>
			  	</li>
              	<li>
					<BiCheck className='service__list-icon'/>
					<p>Supervised ML algorithms</p>
			  	</li>
			  	<li>
					<BiCheck className='service__list-icon'/>
					<p>Unsupervised ML algorithms</p>
			  	</li>
			  	<li>
					<BiCheck className='service__list-icon'/>
					<p>Data Analysis and Visualization</p>
			  	</li>
			  	<li>
					<BiCheck className='service__list-icon'/>
					<p>Deep Learning</p>
			  	</li>
            </ul>

        </article>
		{/* END OF WEB DEVELOPMENT */}
        
		<article className="service">

          	<div className="service__head">
            	<h3>Backend Developement</h3>
			</div>

            <ul className="service__list">
              	<li>
					<BiCheck className='service__list-icon'/>
					<p>Express.js & Flask</p>
			  	</li>
			  	<li>
					<BiCheck className='service__list-icon'/>
					<p>Oracle, MySQL, Postgress</p>
			  	</li>
			  	<li>
					<BiCheck className='service__list-icon'/>
					<p>MongoDB</p>
			  	</li>
			  	<li>
					<BiCheck className='service__list-icon'/>
					<p>Sanity</p>
			  	</li>
			  	<li>
					<BiCheck className='service__list-icon'/>
					<p>authentication, authorization and error handling</p>
			  	</li>
			  	<li>
					<BiCheck className='service__list-icon'/>
					<p>Payment gateways integration.</p>
			  	</li>
            </ul>

        </article>
		{/* END OF CONTENT CREATION */}
      </div>
    </section>
  )
}

export default Services